// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2H0Dm","content":"ManualTimeModal_content__moY0J"};